<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <main v-if="!isNil(inquiry)" class="main main--has-floating-buttons">
    <card :title="$t('pageHotelInquiry.card.general')" cols="12 6@tablet 4@desktop 3@hd">
      <hm-card-inner>
        <hm-col :grid="true" cols="12">
          <hm-input-date v-model="inquiry.arrivalDate"
                         :disabled="true"
                         :label="$t('pageHotelInquiry.arrivalDate')"
                         cols="12 6@tablet"
                         name="arrivalDate" />
          <hm-input-date v-model="inquiry.departureDate"
                         :disabled="true"
                         :label="$t('pageHotelInquiry.departureDate')"
                         cols="12 6@tablet"
                         name="departureDate" />
          <hm-input :value="inquiry.createdAt | toLocalDateTime"
                    :disabled="true"
                    :label="$t('pageHotelInquiry.inquiryCreatedAt')"
                    cols="12"
                    name="inquiryCreatedAt" />
          <hm-input v-if="!isNil(inquiry.ipAddress) && hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                    :value="inquiry.ipAddress"
                    :disabled="true"
                    :label="$t('pageHotelInquiry.ipAddress')"
                    cols="12"
                    name="ipAddress" />
          <hm-input-toggle v-model="inquiry.completed"
                           :label="$t('pageHotelInquiry.completed')"
                           :enabled-title="$t('pageHotelInquiry.completedEnabled')"
                           :disabled-title="$t('pageHotelInquiry.completedDisabled')"
                           name="completed" />
        </hm-col>
      </hm-card-inner>
    </card>
    <card :title="$t('pageHotelInquiry.card.remarks')" cols="12 6@tablet 4@desktop 3@hd">
      <hm-card-inner>
        <hm-textarea v-model="inquiry.guestComment" :label="$t('pageHotelInquiry.guestComment')" name="guestComment" />
      </hm-card-inner>
      <hm-card-inner :title="$t('pageHotelInquiry.card.optIns')">
        <label-value-dotted v-for="(row) in inquiry.optIns" :label="row" :key="row" value="Ja" />
      </hm-card-inner>
    </card>

    <template v-for="(room, idx) in inquiry.rooms">
      <card :title="$t('pageHotelInquiry.card.room', { idx: (idx + 1) })" :key="room.id" cols="12 6@tablet 4@desktop 3@hd">
        <hm-card-inner>
          <hm-col cols="12">
            <div style="position:relative; margin-bottom: 0.8rem;">{{ $t('pageHotelInquiry.hintAutoDetectionSmartMatching') }}</div>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner>
          <hm-input :value="room.roomTypeName"
                    :disabled="true"
                    :label="$t('pageHotelInquiry.inquiryRoomType')"
                    cols="12"
                    name="inquiryRoomType" />
          <hm-input-select v-model="room.roomTypeId" :vague="!room.roomTypeExactMatch" :label="$t('pageHotelInquiry.roomType')" name="roomType">
            <option v-for="item in hotelSettings.roomTypes.all(room.roomTypeId)" :value="item.id" v-html="item.name[$shortLocale]"></option>
          </hm-input-select>
          <hm-input :value="room.ratePlanName"
                    :disabled="true"
                    :label="$t('pageHotelInquiry.inquiryRatePlan')"
                    cols="12"
                    name="inquiryRatePlan" />
          <hm-input-select v-model="room.ratePlanId" :vague="!room.ratePlanExactMatch" :label="$t('pageHotelInquiry.ratePlan')" name="ratePlan">
            <option v-for="item in hotelSettings.ratePlans.all(room.ratePlanId)" :value="item.id" v-html="item.name[$shortLocale]"></option>
          </hm-input-select>
          <hm-input-select v-model="room.numAdults"
                           :disabled="true"
                           :label="$t('pageHotelInquiry.numAdults')"
                           name="numAdults"
                           cols="12">
            <option v-for="item in intArray(100)" :value="item" :disabled="item > (99 - room.numChildren)" v-html="item"></option>
          </hm-input-select>
          <hm-input-select v-if="hasLicense('ChildRates')"
                           v-model="room.numChildren"
                           :disabled="true"
                           :label="$t('pageHotelInquiry.numChildren')"
                           name="numChildren"
                           cols="12"
                           @input="onUpdateNumChildren(room)"
                           @change="onUpdateNumChildren(room)">
            <option v-for="item in intArray(100)" :value="item" :disabled="item > (99 - room.numAdults)" v-html="item"></option>
          </hm-input-select>
          <hm-input-select v-for="child in intArray(room.numChildren)"
                           v-if="!isNil(room.childAgeCategories)"
                           v-model="room.childAgeCategories[child+1]"
                           :vague="!room.childAgeExactMatch"
                           :label="$tc('pageHotelInquiry.child', child, { count: child+1 })"
                           :key="child"
                           :required="true"
                           name="childAge"
                           cols="12">
            <option v-for="item in hotelSettings.ageCategories.all(room.childAgeCategories[child+1])" v-if="item.ageQualifier === 'Adult'" :value="item.id" v-html="`${item.name[$shortLocale]}`"></option>
            <option v-for="item in hotelSettings.ageCategories.all(room.childAgeCategories[child+1])" v-if="item.ageQualifier !== 'Adult'" :value="item.id" v-html="`${item.name[$shortLocale]} (${item.ageFrom} - ${item.ageUntil})`"></option>
          </hm-input-select>
        </hm-card-inner>
      </card>
    </template>

    <card :title="$t('pageHotelInquiry.card.availabilities')" cols="12 6@tablet 4@desktop 3@hd">
      <hm-card-inner>
        <hm-col cols="12">
          <div style="position:relative; margin-bottom: 0.8rem;">{{ $t('pageHotelInquiry.card.hintAvailabilities') }}</div>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner>
        <hm-col :grid="true" cols="12">
          <hm-input-date v-model="arrivalDate" :label="$t('pageHotelInquiry.arrivalDate')" cols="12 6@tablet" name="arrivalDate" />
          <hm-input-date v-model="departureDate"
                         :min-date="arrivalDate"
                         :label="$t('pageHotelInquiry.departureDate')"
                         cols="12 6@tablet"
                         name="departureDate" />
        </hm-col>
      </hm-card-inner>
      <hm-card-inner v-if="!isNil(arrivalDate) && !isNil(departureDate) && !isEmpty(roomTypeAvailability)">
        <label-value-dotted v-for="avail in roomTypeAvailability"
                            v-if="!findHotelSettingById('roomTypes', avail.roomTypeId).deleted || avail.count > 0"
                            :value="avail.count"
                            :label="findHotelSettingById('roomTypes', avail.roomTypeId).name[$shortLocale]"
                            :key="avail.roomTypeId" />
      </hm-card-inner>
    </card>

    <card :title="$t('pageHotelInquiry.card.guest')" cols="12 6@tablet 4@desktop 3@hd start-1 start-7@tablet start-9@desktop start-10@hd" rows="1 2@desktop start-1">
      <hm-card-inner>
        <guest-profile-editor id="editor_guest" v-model="inquiry.guestDetail.guestProfileId" type="Guest" />
      </hm-card-inner>
    </card>

    <card v-if="!isNil(correspondence)" :title="$t('pageHotelInquiry.card.correspondence')" cols="12" min-height="20rem">
      <hm-card-inner :full-size="true">
        <hm-col cols="12">
          <correspondence-table :correspondence="correspondence" :items-per-page="10" />
        </hm-col>
      </hm-card-inner>
    </card>

    <card :title="$t('pageHotelInquiry.card.additionalInformation')" cols="12" card-type="collapsible">
      <hm-card-inner :title="$t('pageHotelInquiry.card.rawData')">
        <hm-col cols="12">
          <pre class="privacy--blur">{{ rawData }}</pre>
        </hm-col>
      </hm-card-inner>
    </card>

    <hm-floating-buttons ref="floatingButtons">
      <hm-floating-button :label="$t('pageHotelInquiry.actions.createEmail')" icon="send-email" color="blue" @click="$router.push({ name: 'inquiryEmail', params: $route.params})" />
      <hm-floating-button v-if="!isEmpty(inquiry.offerId)"
                          :label="$t('pageHotelInquiry.actions.openOffer')"
                          icon="eye"
                          color="green"
                          @click="$router.push({ name: 'offer', params: { guestOfferId: inquiry.offerId } })" />
      <hm-floating-button v-else
                          :label="$t('pageHotelInquiry.actions.createOffer')"
                          icon="save"
                          color="green"
                          @click="createOffer" />
    </hm-floating-buttons>


  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import {
  isArray,
  join,
  isNil,
  isEmpty,
  get,
  filter,
  last,
  find,
  nth,
  template,
  clone,
  cloneDeep,
  isEqual,
  isObject,
  debounce,
  lowerCase,
  head,
} from 'lodash';
import HmCol from '../lib/layout/HmCol';
import HmTable from '../lib/table/HmTable';
import { util } from 'protobufjs/minimal';
import HmCardInner from '../lib/layout/HmCardInner';
import SaveWatchMixin from '../../mixins/SaveWatchMixin';

export default {
  name: 'PageHotelInquiry',
  components: { HmCardInner, HmCol, HmTable },

  mixins: [HotelmeisterMixin, SaveWatchMixin],

  autosave: [
    {
      name: 'inquiry',
      variable: 'inquiry',
      fn: function (cbSaveComplete) {
        const inquiry = cloneDeep(this.inquiry);
        this.axios.put(this.serviceUrls.inquiry.get(this, this.inquiryId), {
          guestComment: inquiry.guestComment,
          rooms: inquiry.rooms,
          completed: inquiry.completed,
          guestProfileId: inquiry.guestDetail.guestProfileId,
        })
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      arrivalDate: null,
      departureDate: null,
      debouncedUpdateRoomTypeAvailability: null,
      roomTypeAvailability: [],
      inquiry: null,
      correspondence: null,
      inquiryId: null,
    };
  },

  computed: {
    rawData() {
      try {
        return JSON.parse(this.inquiry.rawData);
      } catch (e) {
        return this.inquiry.rawData;
      }
    },
  },

  watch: {
    arrivalDate: function () {
      if (!isEmpty(this.arrivalDate) && !isEmpty(this.departureDate)) this.debouncedUpdateRoomTypeAvailability();
    },
    departureDate: function () {
      if (!isEmpty(this.arrivalDate) && !isEmpty(this.departureDate)) this.debouncedUpdateRoomTypeAvailability();
    },
  },

  created: function () {
    this.inquiryId = this.$route.params.inquiryId;
    this.debouncedUpdateRoomTypeAvailability = debounce(this.updateRoomTypeAvailability, 250);
    this.updateInquiry();
    this.updateCorrespondence();
  },

  methods: {
    updateRoomTypeAvailability: function () {
      if (isEmpty(this.arrivalDate) || isEmpty(this.departureDate)) {
        this.roomTypeAvailability = [];
      }

      const days = this.$moment.duration(this.$moment(this.departureDate, 'YYYYMMDD').diff(this.arrivalDate)).asDays();

      this.axios.get(this.serviceUrls.roomTypePlan(this), {
        params: {
          start: this.arrivalDate,
          limit: Math.abs(Math.round(days)) - 1,
        },
        headers: {
          Accept: 'application/x-protobuf',
        },
        responseType: 'arraybuffer',
      }).then((response) => {
        this.roomTypeAvailability = [];

        const byRoomType = response.data.data.ByRoomType;

        if (!isNil(byRoomType)) {
          const keys = Object.keys(byRoomType);
          this.hotelSettings.roomTypes.all()
            .forEach((roomType) => {
              const count = head(
                keys.map(date => response.data.data.ByRoomType[date].value[roomType.id])
                  .sort((a, b) => a - b),
              );

              this.roomTypeAvailability.push({
                roomTypeId: roomType.id,
                count: count,
              });
            });
        }
      });
    },
    createOffer() {
      return this.axios
        .post(this.serviceUrls.inquiry.createOffer(this, this.inquiryId))
        .then((response) => {
          if (!isEmpty(response.data.data)) {
            this.$router.push({ name: 'offer', params: { guestOfferId: response.data.data } });
          }
          this.showMessages(response);
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    updateInquiry() {
      return this.axios
        .get(this.serviceUrls.inquiry.get(this, this.inquiryId))
        .then((response) => {
          const inquiry = response.data.data;
          if (!isNil(inquiry.rooms)) {
            inquiry.rooms.forEach((room) => {
              this.onUpdateNumChildren(room);
            });
          }

          this.inquiry = inquiry;
          this.arrivalDate = this.inquiry.arrivalDate;
          this.departureDate = this.inquiry.departureDate;
        });
    },
    onUpdateNumChildren: function (room) {
      const children = this.intArray(room.numChildren, 1);
      if (isNil(room.childAgeCategories)) room.childAgeCategories = [];
      const defaultAgeCategoryId = isNil(this.hotelSettings.ageCategories.all().find(it => it.ageQualifier !== 'Adult'))
        ? this.hotelSettings.ageCategories.all().find(it => it.ageQualifier === 'Adult').id
        : this.hotelSettings.ageCategories.all().find(it => it.ageQualifier !== 'Adult').id;
      children.forEach((it) => {
        if (isEmpty(get(room.childAgeCategories, it, null))) {
          room.childAgeCategories[it] = defaultAgeCategoryId;
        }
      });
    },
    updateCorrespondence() {
      return this.axios
        .get(this.serviceUrls.inquiry.correspondence(this, this.inquiryId))
        .then((response) => {
          this.correspondence = response.data.data;
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

</style>

<style lang="scss">
  @import '~styles/import';

</style>



// WEBPACK FOOTER //
// src/components/pages/PageHotelInquiry.vue